module.exports = __webpack_public_path__ + "af054b7ff0dacac3517e9cb66c7f3927.MP3";